import React, { FC, memo } from 'react';
import cn from 'classnames';
import './Loader.scss';

export type LoaderSize = 'mini' | 'small' | 'medium' | 'large';
export type LoaderColor = 'white' | 'black' | 'green';

export interface ILoaderProps {
  className?: string;
  size?: LoaderSize;
  color?: LoaderColor;
  speed?: 'slow' | 'normal' | 'fast';
}

const Loader: FC<ILoaderProps> = ({
                                    className,
                                    size = 'medium',
                                    color = 'green',
                                    speed = 'normal',
                                  }) => {
  const sizeClasses = {
    mini: 'loader-size-mini',
    small: 'loader-size-small',
    medium: 'loader-size-medium',
    large: 'loader-size-large',
  };

  const colorClasses = {
    white: 'loader-color-white',
    black: 'loader-color-black',
    green: 'loader-color-green',
  };

  const speedClasses = {
    slow: 'loader-speed-slow',
    normal: 'loader-speed-normal',
    fast: 'loader-speed-fast',
  };

  return (
    <div className={cn('loader-container', className)}>
      <div
        className={cn(
          'loader',
          sizeClasses[size],
          colorClasses[color],
          speedClasses[speed],
        )}
      />
    </div>
  );
};

export default memo(Loader);
